import axios from 'axios';
import configurationsEscl from '../locales/es-CL/configurations.json';
import configurationsEsmx from '../locales/es-MX/configurations.json';
import configurationsEsco from '../locales/es-CO/configurations.json';
import configurationsEnus from '../locales/en-US/configurations.json';
import showAlert from '../alert/alertHandler';

import showConfirmation from '@waypoint/vue-confirmation';
export default {
  name: 'configurations',
  i18n: {
    messages: {
      'es-CL': {
        configurations: configurationsEscl,
      },
      'es-MX': {
        configurations: configurationsEsmx,
      },
      'es-CO': {
        configurations: configurationsEsco,
      },
      'en-US': {
        configurations: configurationsEnus,
      },
    },
  },
  data() {
    return {
      currentTab: 'notification',
      searchEmail: null,
      newEditEmail: null,
      emailsEvents: null,
      selectedEmailEdit: null,
      isEmailNotificationBusy: false,
      isSendPreviewReady: false,
      isEmailMoreThanOne: false,
      cooldown: 0,
      selectedEventNotification: null,
      newEmail: null,
      copyEmail: false,
      dataAccess: null,
      imageBussy: false,
      fileActivity: null,
      fileBase64: null,
      notificationDestination: [],
      notificationTypes: [],
      notificationClient: [],
      isCollapseClicked: false,
      isConfigurationsReady: false,
      selectedType: null,
      nameUser: null,
      nameClient: null,
      badges: {
        SCHEDULED_ORDER: {
          background: '#F7F8F9',
          color: '#566A7F',
          border: '1px solid #566A7F',
        },
        ONROUTE_ORDER: {
          background: '#F3FAFE',
          color: '#139DEA',
          border: '1px solid #139DEA',
        },
        SUCCESSFUL_ORDER: {
          background: '#F6FAF6',
          color: '#52A145',
          border: '1px solid #52A145',
        },
        PARTIAL_ORDER: {
          background: '#FEFAF4',
          color: '#E69C21',
          border: '1px solid #E69C21',
        },
        FAILED_ORDER: {
          background: '#FCF4F4',
          color: '#C32329',
          border: '1px solid #C32329',
        },
        DESTINATION: {
          background: '#F3FAFE',
          color: '#139DEA',
          border: '1px solid #139DEA',
        },
      },
      eventList:[
        {
          eventName: "SCHEDULED_ORDER",
          description: this.$t(`configurations.titles.SCHEDULED_ORDER`),
          id: 2
        },
        {
          eventName: "ONROUTE_ORDER",
          description: this.$t(`configurations.titles.ONROUTE_ORDER`),
          id: 3
        },
        {
          eventName: "SUCCESSFUL_ORDER",
          description: this.$t(`configurations.titles.SUCCESSFUL_ORDER`),
          id: 4
        },
        {
          eventName: "PARTIAL_ORDER",
          description: this.$t(`configurations.titles.PARTIAL_ORDER`),
          id: 5
        },
        {
          eventName: "FAILED_ORDER",
          description: this.$t(`configurations.titles.FAILED_ORDER`),
          id: 6
        },
        /* {
          eventName: "DESTINATION",
          description: this.$t(`configurations.titles.DESTINATION`),
          id: 7
        }, */
      ],
      isNotificationEditedPending: false,
      eventSelectedEdited: null,
      scheduledNotStruct: {},
      onRouteNotStruct: {},
      successNotStruct: {},
      partialNotStruct: {},
      failedNotStruct: {},
      sendEmail: null,
      eventSelected: null,
      urlImage: null,
      subjectCustomerName: false,
      subjectSenderName: false,
      subjectClientName: false,
      isLogoEnabled: false,
      bodyCustomerName: false,
      bodySenderName: false,
      bodyClientName: false,
      bodyDeliveryDate: false,
      bodyEstimatedArriveDate: false,
      bodyDeliveryAddress: false,
      bodyOperationName: false,
      bodyReceiverName: false,
      bodyReceiverLegalNumber: false,
      extraDriverName: false,
      extraDriverPhone: false,
      extraPlate: false,
      extraDocuments: false,
      extraItems: false,
      extraTrackingUrl: false,
      extraTrackingId: false,
      extraPhotos: false,
      extraObservation: false,
      extraSurvey: false,
      extraMotiveSubmotive: false,
      refreshUrlImage: null,
      refreshSubjectCustomerName: false,
      refreshSubjectSenderName: false,
      refreshSubjectClientName: false,
      refreshIsLogoEnabled: false,
      refreshBodyCustomerName: false,
      refreshBodySenderName: false,
      refreshBodyClientName: false,
      refreshBodyDeliveryDate: false,
      refreshBodyEstimatedArriveDate: false,
      refreshBodyDeliveryAddress: false,
      refreshBodyOperationName: false,
      refreshBodyReceiverName: false,
      refreshBodyReceiverLegalNumber: false,
      refreshExtraDriverName: false,
      refreshExtraDriverPhone: false,
      refreshExtraPlate: false,
      refreshExtraDocuments: false,
      refreshExtraItems: false,
      refreshExtraTrackingUrl: false,
      refreshExtraTrackingId: false,
      refreshExtraPhotos: false,
      refreshExtraObservation: false,
      refreshExtraSurvey: false,
      refreshExtraMotiveSubmotive: false,
    };
  },
  async created() {
    this.prepareData();
  },
  methods: {
    async changeTab(navBar) {
      if(navBar === 'editNotification' && this.currentTab !== 'editNotification'){
        this.fileActivity = undefined;
      }
      const ranking = ['notification', 'copyNotification'];
      this.currentTab = navBar;
      const currentTabIndex = ranking.indexOf(this.currentTab);
      this.indexTab = currentTabIndex;
    },
    async prepareData() {
      this.isConfigurationsReady = false;
      this.dataAccess = this.$store.getters.dataAccess;
      this.nameUser = `${this.$store.getters.loggedUser['firstName']}  ${this.$store.getters.loggedUser['lastName']}`;
      this.nameClient = this.$store.getters.clientName;
      await this.getNotifications();
      this.bodyNotification();
      this.isConfigurationsReady = true;
    },
    //trae la informacion de los correos que reciben los eventos
    async getNotifications() {
      this.notificationTypes= [];
      this.notificationDestination = [];
      const urlNotification = `${this.$store.getters.urlAPI}/notification?notificationType=email`;
      try {
        const config = {
          headers: {
            'id-client': this.$store.getters.clientId,
            Authorization: `Bearer ${this.$store.getters.accessToken}`,
          },
        };
        const notificacionData = await axios.get(urlNotification, config);
        const data = notificacionData.data.data;
        data.types.forEach((type) => {
          if(type.name !== 'DESTINATION'){
            this.notificationTypes.push(type);
          }else{
            this.notificationDestination.push(type);
          }
        });
        if (this.selectedEventNotification !== null && this.selectedEventNotification !== undefined) {
          this.selectedEventNotification = this.notificationTypes.find(
            (type) => type.id == this.selectedEventNotification,
          ).id;
        }
        this.notificationClient = data.notifications;
        this.notificationClient.forEach((noti) => {
          if (noti.metaDataByClient) {
            this.urlImage = noti.metaDataByClient.logo;
          }
        });
        await this.obtainNotificationDetail();
      } catch (e) {
        console.log(e);
      }
    },
    async obtainNotificationDetail() {
      let subjectCustomerName = false;
      let subjectSenderName = false;
      let subjectClientName = false;
      let isLogoEnabled = false;
      let bodyCustomerName = false;
      let bodySenderName = false;
      let bodyClientName = false;
      let bodyDeliveryDate = false;
      let bodyEstimatedArriveDate = false;
      let bodyDeliveryAddress = false;
      let bodyOperationName = false;
      let bodyReceiverName = false;
      let bodyReceiverLegalNumber = false;
      let extraDriverName = false;
      let extraDriverPhone = false;
      let extraPlate = false;
      let extraDocuments = false;
      let extraItems = false;
      let extraTrackingUrl = false;
      let extraTrackingId = false;
      let extraPhotos = false;
      let extraObservation = false;
      let extraSurvey = false;
      let extraMotiveSubmotive = false;

      let isSchedDone = false;
      let isOnRouteDone = false;
      let isSuccessDone = false;
      let isPartialDone = false;
      let isFailedDone = false;

      this.notificationClient.forEach((noti) => {
        subjectCustomerName = false;
        subjectSenderName = false;
        subjectClientName = false;
        isLogoEnabled = false;
        bodyCustomerName = false;
        bodySenderName = false;
        bodyClientName = false;
        bodyDeliveryDate = false;
        bodyEstimatedArriveDate = false;
        bodyDeliveryAddress = false;
        bodyOperationName = false;
        bodyReceiverName = false;
        bodyReceiverLegalNumber = false;
        extraDriverName = false;
        extraDriverPhone = false;
        extraPlate = false;
        extraDocuments = false;
        extraItems = false;
        extraTrackingUrl = false;
        extraTrackingId = false;
        extraPhotos = false;
        extraObservation = false;
        extraSurvey = false;
        extraMotiveSubmotive = false;
        if (noti.metaDataByClient) {
          let logo = noti.metaDataByClient.logo;          
          if (noti.metaDataByClient.subjectCustomerName) {
            subjectCustomerName = noti.metaDataByClient.subjectCustomerName == 'true';
          }
          if (noti.metaDataByClient.subjectSenderName) {
            subjectSenderName = noti.metaDataByClient.subjectSenderName == 'true';
          }
          if (noti.metaDataByClient.subjectClientName) {
            subjectClientName = noti.metaDataByClient.subjectClientName == 'true';
          }
          if (noti.metaDataByClient.isLogoEnabled) {
            isLogoEnabled = noti.metaDataByClient.isLogoEnabled == 'true';
          }
          if (noti.metaDataByClient.bodyCustomerName) {
            bodyCustomerName = noti.metaDataByClient.bodyCustomerName == 'true';
          }
          if (noti.metaDataByClient.bodySenderName) {
            bodySenderName = noti.metaDataByClient.bodySenderName == 'true';
          }
          if (noti.metaDataByClient.bodyClientName) {
            bodyClientName = noti.metaDataByClient.bodyClientName == 'true';
          }
          if (noti.metaDataByClient.bodyDeliveryDate) {
            bodyDeliveryDate = noti.metaDataByClient.bodyDeliveryDate == 'true';
          }
          if (noti.metaDataByClient.bodyEstimatedArriveDate) {
            bodyEstimatedArriveDate = noti.metaDataByClient.bodyEstimatedArriveDate == 'true';
          }
          if (noti.metaDataByClient.bodyDeliveryAddress) {
            bodyDeliveryAddress = noti.metaDataByClient.bodyDeliveryAddress == 'true';
          }
          if (noti.metaDataByClient.bodyOperationName) {
            bodyOperationName = noti.metaDataByClient.bodyOperationName == 'true';
          }
          if (noti.metaDataByClient.bodyReceiverName) {
            bodyReceiverName = noti.metaDataByClient.bodyReceiverName == 'true';
          }
          if (noti.metaDataByClient.bodyReceiverLegalNumber) {
            bodyReceiverLegalNumber = noti.metaDataByClient.bodyReceiverLegalNumber == 'true';
          }
          if (noti.metaDataByClient.extraDriverName) {
            extraDriverName = noti.metaDataByClient.extraDriverName == 'true';
          }
          if (noti.metaDataByClient.extraDriverPhone) {
            extraDriverPhone = noti.metaDataByClient.extraDriverPhone == 'true';
          }
          if (noti.metaDataByClient.extraPlate) {
            extraPlate = noti.metaDataByClient.extraPlate == 'true';
          }else{
            extraPlate = false;
          }
          if (noti.metaDataByClient.extraDocuments) {
            extraDocuments = noti.metaDataByClient.extraDocuments == 'true';
          }else{
            extraDocuments = false;
          }
          if (noti.metaDataByClient.extraItems) {
            extraItems = noti.metaDataByClient.extraItems == 'true';
          }else{
            extraItems = false;
          }
          if (noti.metaDataByClient.extraTrackingUrl) {
            extraTrackingUrl = noti.metaDataByClient.extraTrackingUrl == 'true';
          }else{
            extraTrackingUrl = false;
          }
          if (noti.metaDataByClient.extraTrackingId) {
            extraTrackingId = noti.metaDataByClient.extraTrackingId == 'true';
          }else{
            extraTrackingId = false;
          }
          if (noti.metaDataByClient.extraPhotos) {
            extraPhotos = noti.metaDataByClient.extraPhotos == 'true';
          }else{
            extraPhotos = false;
          }
          if (noti.metaDataByClient.extraObservation) {
            extraObservation = noti.metaDataByClient.extraObservation == 'true';
          }
          if (noti.metaDataByClient.extraSurvey) {
            extraSurvey = noti.metaDataByClient.extraSurvey == 'true';
          }
          if (noti.metaDataByClient.extraMotiveSubmotive) {
            extraMotiveSubmotive = noti.metaDataByClient.extraMotiveSubmotive == 'true';
          }else{
            extraMotiveSubmotive = false;
          }
          if (
            !subjectCustomerName && 
            !subjectSenderName && 
            !subjectClientName && 
            !isLogoEnabled && 
            !bodyCustomerName && 
            !bodySenderName && 
            !bodyClientName && 
            !bodyDeliveryDate && 
            !bodyEstimatedArriveDate && 
            !bodyDeliveryAddress && 
            !bodyOperationName && 
            !bodyReceiverName && 
            !bodyReceiverLegalNumber && 
            !extraDriverName && 
            !extraDriverPhone && 
            !extraPlate && 
            !extraDocuments && 
            !extraItems && 
            !extraTrackingUrl && 
            !extraTrackingId && 
            !extraPhotos && 
            !extraObservation && 
            !extraSurvey && 
            !extraMotiveSubmotive) {
              if (noti.notificationTypeName == 'SCHEDULED_ORDER') {
                subjectCustomerName = true;
                subjectClientName = true;
                bodyCustomerName = true;
                bodyClientName = true;
                bodyEstimatedArriveDate = true;
                bodyDeliveryAddress = true;
                bodyOperationName = true;
              }
              if (noti.notificationTypeName == 'ONROUTE_ORDER') {
                subjectCustomerName = true;
                subjectClientName = true;
                bodyCustomerName = true;
                bodyClientName = true;
                bodyEstimatedArriveDate = true;
                bodyDeliveryAddress = true;
                bodyOperationName = true;
                extraTrackingUrl = true;
                extraTrackingId = true;
              }
              if (noti.notificationTypeName == 'SUCCESSFUL_ORDER') {
                subjectCustomerName = true;
                subjectClientName = true;
                bodyCustomerName = true;
                bodyClientName = true;
                bodyDeliveryDate = true;
                bodyDeliveryAddress = true;
                bodyOperationName = true;
                extraSurvey = true;
              }
              if (noti.notificationTypeName == 'PARTIAL_ORDER') {
                subjectCustomerName = true;
                subjectClientName = true;
                bodyCustomerName = true;
                bodyClientName = true;
                bodyDeliveryDate = true;
                bodyDeliveryAddress = true;
                bodyOperationName = true;
                extraSurvey = true;
              }
              if (noti.notificationTypeName == 'FAILED_ORDER') {
                subjectCustomerName = true;
                subjectClientName = true;
                bodyCustomerName = true;
                bodyClientName = true;
                bodyDeliveryDate = true;
                bodyDeliveryAddress = true;
                bodyOperationName = true;
              }
            }
            let bodyTemp = {};
            bodyTemp.subjectCustomerName = subjectCustomerName;
            bodyTemp.subjectSenderName = subjectSenderName;
            bodyTemp.subjectClientName = subjectClientName;
            bodyTemp.isLogoEnabled = isLogoEnabled;
            bodyTemp.bodyCustomerName = bodyCustomerName;
            bodyTemp.bodySenderName = bodySenderName;
            bodyTemp.bodyClientName = bodyClientName;
            bodyTemp.bodyDeliveryDate = bodyDeliveryDate;
            bodyTemp.bodyEstimatedArriveDate = bodyEstimatedArriveDate;
            bodyTemp.bodyDeliveryAddress = bodyDeliveryAddress;
            bodyTemp.bodyOperationName = bodyOperationName;
            bodyTemp.bodyReceiverName = bodyReceiverName;
            bodyTemp.bodyReceiverLegalNumber = bodyReceiverLegalNumber;
            bodyTemp.extraDriverName = extraDriverName;
            bodyTemp.extraDriverPhone = extraDriverPhone;
            bodyTemp.extraPlate = extraPlate;
            bodyTemp.extraDocuments = extraDocuments;
            bodyTemp.extraItems = extraItems;
            bodyTemp.extraTrackingUrl = extraTrackingUrl;
            bodyTemp.extraTrackingId = extraTrackingId;
            bodyTemp.extraPhotos = extraPhotos;
            bodyTemp.extraObservation = extraObservation;
            bodyTemp.extraSurvey = extraSurvey;
            bodyTemp.extraMotiveSubmotive = extraMotiveSubmotive;
            bodyTemp.logo = logo;
            if (noti.notificationTypeName == 'SCHEDULED_ORDER') {
              this.scheduledNotStruct = bodyTemp;
              isSchedDone = true;
            }
            if (noti.notificationTypeName == 'ONROUTE_ORDER') {
              this.onRouteNotStruct = bodyTemp;
              isOnRouteDone = true;
            }
            if (noti.notificationTypeName == 'SUCCESSFUL_ORDER') {
              this.successNotStruct = bodyTemp;
              isSuccessDone = true;
            }
            if (noti.notificationTypeName == 'PARTIAL_ORDER') {
              this.partialNotStruct = bodyTemp;
              isPartialDone = true;
            }
            if (noti.notificationTypeName == 'FAILED_ORDER') {
              console.log("Entre aca y que pasaaaa ",bodyTemp);
              this.failedNotStruct = bodyTemp;
              isFailedDone = true;
            }
        } else {
          if (noti.notificationTypeName == 'SCHEDULED_ORDER') {
            subjectCustomerName = true;
            subjectClientName = true;
            bodyCustomerName = true;
            bodyClientName = true;
            bodyEstimatedArriveDate = true;
            bodyDeliveryAddress = true;
            bodyOperationName = true;
            isSchedDone = true;
          }
          if (noti.notificationTypeName == 'ONROUTE_ORDER') {
            subjectCustomerName = true;
            subjectClientName = true;
            bodyCustomerName = true;
            bodyClientName = true;
            bodyEstimatedArriveDate = true;
            bodyDeliveryAddress = true;
            bodyOperationName = true;
            extraTrackingUrl = true;
            extraTrackingId = true;
            isOnRouteDone = true;
          }
          if (noti.notificationTypeName == 'SUCCESSFUL_ORDER') {
            subjectCustomerName = true;
            subjectClientName = true;
            bodyCustomerName = true;
            bodyClientName = true;
            bodyDeliveryDate = true;
            bodyDeliveryAddress = true;
            bodyOperationName = true;
            extraSurvey = true;
            isSuccessDone = true;
          }
          if (noti.notificationTypeName == 'PARTIAL_ORDER') {
            subjectCustomerName = true;
            subjectClientName = true;
            bodyCustomerName = true;
            bodyClientName = true;
            bodyDeliveryDate = true;
            bodyDeliveryAddress = true;
            bodyOperationName = true;
            extraSurvey = true;
          }
          if (noti.notificationTypeName == 'FAILED_ORDER') {
            subjectCustomerName = true;
            subjectClientName = true;
            bodyCustomerName = true;
            bodyClientName = true;
            bodyDeliveryDate = true;
            bodyDeliveryAddress = true;
            bodyOperationName = true;
            isFailedDone = true;
          }
        }
      });

      if (!isSchedDone || !isOnRouteDone || !isSuccessDone || !isPartialDone || !isFailedDone) {
        let bodyTemp = {};
        bodyTemp.subjectCustomerName = subjectCustomerName;
        bodyTemp.subjectSenderName = subjectSenderName;
        bodyTemp.subjectClientName = subjectClientName;
        bodyTemp.isLogoEnabled = isLogoEnabled;
        bodyTemp.bodyCustomerName = bodyCustomerName;
        bodyTemp.bodySenderName = bodySenderName;
        bodyTemp.bodyClientName = bodyClientName;
        bodyTemp.bodyDeliveryDate = bodyDeliveryDate;
        bodyTemp.bodyEstimatedArriveDate = bodyEstimatedArriveDate;
        bodyTemp.bodyDeliveryAddress = bodyDeliveryAddress;
        bodyTemp.bodyOperationName = bodyOperationName;
        bodyTemp.bodyReceiverName = bodyReceiverName;
        bodyTemp.bodyReceiverLegalNumber = bodyReceiverLegalNumber;
        bodyTemp.extraDriverName = extraDriverName;
        bodyTemp.extraDriverPhone = extraDriverPhone;
        bodyTemp.extraPlate = extraPlate;
        bodyTemp.extraDocuments = extraDocuments;
        bodyTemp.extraItems = extraItems;
        bodyTemp.extraTrackingUrl = extraTrackingUrl;
        bodyTemp.extraTrackingId = extraTrackingId;
        bodyTemp.extraPhotos = extraPhotos;
        bodyTemp.extraObservation = extraObservation;
        bodyTemp.extraSurvey = extraSurvey;
        bodyTemp.extraMotiveSubmotive = extraMotiveSubmotive;

        if (!isSchedDone) {
          //SCHEDULED_ORDER
          this.scheduledNotStruct = bodyTemp;
          this.scheduledNotStruct.subjectCustomerName = true;
          this.scheduledNotStruct.subjectClientName = true;
          this.scheduledNotStruct.bodyCustomerName = true;
          this.scheduledNotStruct.bodyClientName = true;
          this.scheduledNotStruct.bodyEstimatedArriveDate = true;
          this.scheduledNotStruct.bodyDeliveryAddress = true;
          this.scheduledNotStruct.bodyOperationName = true;
        }

        if (!isOnRouteDone) {
          //ONROUTE_ORDER
          this.onRouteNotStruct = bodyTemp;
          this.onRouteNotStruct.subjectCustomerName = true;
          this.onRouteNotStruct.subjectClientName = true;
          this.onRouteNotStruct.bodyCustomerName = true;
          this.onRouteNotStruct.bodyClientName = true;
          this.onRouteNotStruct.bodyEstimatedArriveDate = true;
          this.onRouteNotStruct.bodyDeliveryAddress = true;
          this.onRouteNotStruct.bodyOperationName = true;
          this.onRouteNotStruct.extraTrackingUrl = true;
          this.onRouteNotStruct.extraTrackingId = true;
        }

        if (!isSuccessDone) {
          //SUCCESSFUL_ORDER
          this.successNotStruct = bodyTemp;
          this.successNotStruct.subjectCustomerName = true;
          this.successNotStruct.subjectClientName = true;
          this.successNotStruct.bodyCustomerName = true;
          this.successNotStruct.bodyClientName = true;
          this.successNotStruct.bodyDeliveryDate = true;
          this.successNotStruct.bodyDeliveryAddress = true;
          this.successNotStruct.bodyOperationName = true;
          this.successNotStruct.extraSurvey = true;
        }

        if (!isPartialDone) {
          //PARTIAL_ORDER
          this.partialNotStruct = bodyTemp;
          this.partialNotStruct.subjectCustomerName = true;
          this.partialNotStruct.subjectClientName = true;
          this.partialNotStruct.bodyCustomerName = true;
          this.partialNotStruct.bodyClientName = true;
          this.partialNotStruct.bodyDeliveryDate = true;
          this.partialNotStruct.bodyDeliveryAddress = true;
          this.partialNotStruct.bodyOperationName = true;
          this.partialNotStruct.extraSurvey = true;
        }

        if (!isFailedDone) {
          //FAILED_ORDER
          this.failedNotStruct = bodyTemp;
          this.failedNotStruct.subjectCustomerName = true;
          this.failedNotStruct.subjectClientName = true;
          this.failedNotStruct.bodyCustomerName = true;
          this.failedNotStruct.bodyClientName = true;
          this.failedNotStruct.bodyDeliveryDate = true;
          this.failedNotStruct.bodyDeliveryAddress = true;
          this.failedNotStruct.bodyOperationName = true;
        }
      }
    },
    async setNotifications(listEmails) {
      const body = [];
      const emails = this.notificationClient;
      this.notificationTypes.forEach((notType) => {
        const notificationEmail = emails.find((email) => email.idNotificationType === notType.id);
        const image =
          notificationEmail && notificationEmail.metaDataByClient ? notificationEmail.metaDataByClient.logo : null;
        //Esto es utilizado para la vista de correos de copia, principalmente porque usa los correos que uno va gestionando
        if (this.currentTab == 'copyNotification' && this.selectedEventNotification === notType.id) {
          body.push({
            idNotificationType: notType.id,
            recipientCopy: listEmails ? listEmails : null,
            enabled: notType.active,
            metaData: {
              logo: image ? image : null,
              clientName: this.$store.getters.clientName,
            },
          });
        } else {
          //Esto modifica el estado de las notificaciones manteniendo sus correos y su metadata intacta
          const copies = notificationEmail && notificationEmail.recipientCopy ?  notificationEmail.recipientCopy : null;
          body.push({
            idNotificationType: notType.id,
            recipientCopy: copies ? copies.toString() : null,
            enabled: notType.active,
            metaData: {
              logo: image ? image : null,
              clientName: this.$store.getters.clientName,
            },
          });
        }
      });
      //Como esto es para las notificaciones de proximidad, no se les pasa el campo de recipientes, pero si el de imagenes
      this.notificationDestination.forEach((proximity)=>{
        const notificationEmail = emails.find((email) => email.idNotificationType === proximity.id);
        const image =
          notificationEmail && notificationEmail.metaDataByClient ? notificationEmail.metaDataByClient.logo : null;
        body.push({
          idNotificationType: proximity.id,
          recipientCopy: null,
          enabled: proximity.active,
          metaData: {
            logo: image ? image : null,
            clientName: this.$store.getters.clientName,
          },
        })
      })
      const urlNotification = `${this.$store.getters.urlAPI}/notification/handlerNotification?notificationType=email`;
      try {
        const config = {
          headers: {
            'id-client': this.$store.getters.clientId,
            Authorization: `Bearer ${this.$store.getters.accessToken}`,
          },
        };
        const notificacionData = await axios.post(urlNotification, body, config);
        return notificacionData.data;
      } catch (e) {
        console.log(e);
        return [];
      }
    },
    nameEvent(event) {
      return this.$t(`configurations.titles.${event.name}`);
    },
    displayEmailsForEvent(event) {
      this.isEmailNotificationBusy = true;
      this.isConfigurationsReady = false;
      this.selectedEventNotification = event.id;
      this.refreshEmails(this.selectedEventNotification);
      this.isConfigurationsReady = true;
      this.isEmailNotificationBusy = false;
    },
    editEmail(email) {
      this.selectedEmailEdit = email;
      this.$bvModal.show('edit-email-modal');
    },
    /**
     * Metodo que se encarga de refrescar los cambios en los correos
     */
    refreshEmails(event) {
      this.emailsEvents = [];
      //Guardo el grupo que contiene los correos del evento seleccionado
      if (this.notificationClient) {
        this.selectedGroupEmails = this.notificationClient.find((email) => email.idNotificationType === event);
        //Guardo en una lista los correos que se tienen del grupo
        if (this.selectedGroupEmails && this.selectedGroupEmails.recipientCopy) {
          const listEmails = this.selectedGroupEmails.recipientCopy.split(',');
          listEmails.forEach((email) => {
            this.emailsEvents.push({
              email: email,
            });
          });
        }
      }
    },
    async createEmail() {
      const regexPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
      let list = [];
      if (!this.selectedEventNotification) {
        showAlert('Error', `${this.$t('configurations.modal.errorNull')}`);
        return;
      }
      if (!this.newEmail) {
        showAlert('Error', `${this.$t('configurations.modal.noEmail')}`);
        return;
      }
      this.isEmailNotificationBusy = true;
      this.isConfigurationsReady = false;
      let statusCreated = false;
      if (this.newEmail && this.selectedEventNotification) {
        let listEmails = '';
        this.newEmail = this.newEmail.replace(/ /g, '');
        this.newEmail = this.newEmail.replace(/;/g, ',');
        list = this.newEmail.split(',');
        await list.every((mail) => {
          if (!regexPattern.test(mail)) {
            showAlert('Error', `${this.$t('configurations.modal.errorCreate')}[${mail}]`);
            this.isConfigurationsReady = true;
            this.isEmailNotificationBusy = false;
            throw 'Error en regex correos';
          }
          return true;
        });
        //Verifico si es que hay emails en el evento seleccionado
        if (this.emailsEvents && this.emailsEvents.length > 0) {
          this.emailsEvents.forEach((email) => {
            listEmails = `${listEmails}${email.email},`;
          });
        }
        listEmails = listEmails + this.newEmail;
        statusCreated = await this.setNotifications(listEmails);
      }
      if (this.selectedEventNotification) {
        if (statusCreated) {
          await this.getNotifications();
          this.bodyNotification();

          this.refreshEmails(this.selectedEventNotification);
          this.newEmail = null;
        } else {
          showAlert('Error', `${this.$t('configurations.modal.errorCreate')}[${this.newEmail}]`);
        }
      }
      this.isConfigurationsReady = true;
      this.isEmailNotificationBusy = false;
    },
    async saveEdit(id) {
      if (this.newEditEmail) {
        this.isEmailNotificationBusy = true;
        this.isConfigBussy = true;
        let statusCreated = false;
        let listEmails = [];
        this.emailsEvents.forEach((currentEmail) => {
          if (currentEmail.email !== this.selectedEmailEdit) {
            listEmails.push(currentEmail.email);
          } else {
            listEmails.push(this.newEditEmail);
          }
        });
        listEmails = listEmails.toString();

        statusCreated = await this.setNotifications(listEmails);

        if (statusCreated) {
          await this.getNotifications();
          this.bodyNotification();
          this.refreshEmails(this.selectedEventNotification);
        } else {
          showAlert('Error', this.$t('webNotification.modal.errorDelete'));
        }
        this.isEmailNotificationBusy = false;
        this.isConfigBussy = false;
      }
      this.newEmail = null;
      this.closeModalEdit(id);
      this.newEditEmail = null;
      this.selectedEmailEdit = null;
    },
    confirmationDelete(email) {
      showConfirmation(
        this.$t('common.modals.confirmacionTitulo'),
        this.$t('configurations.modal.confirmDelete', { email: email }),
        () => {
          this.deleteEmail(email);
        },
        this.$t('common.cruds.aceptar'),
        this.$t('common.cruds.cerrar'),
      );
    },
    async deleteEmail(email) {
      this.isEmailNotificationBusy = true;
      this.isConfigBussy = true;
      let statusCreated = false;
      let listEmails = [];
      if (this.emailsEvents.length > 1) {
        this.emailsEvents.forEach((currentEmail) => {
          if (currentEmail.email !== email) {
            listEmails.push(currentEmail.email);
          }
        });
      }
      listEmails = listEmails.toString();

      statusCreated = await this.setNotifications(listEmails);
      if (statusCreated) {
        await this.getNotifications();
        this.bodyNotification();
        this.refreshEmails(this.selectedEventNotification);
      } else {
        showAlert('Error', this.$t('configurations.modal.errorDelete'));
      }
      this.isConfigBussy = false;
      this.isEmailNotificationBusy = false;
    },
    closeModalEdit(id) {
      this.$bvModal.hide(id);
    },
    bodyNotification() {
      this.notificationTypes = this.buildCollapseLogic(this.notificationTypes);
      this.notificationDestination = this.buildCollapseLogic(this.notificationDestination);
      this.notificationTypes = this.notificationTypes.sort((a, b) => a.id - b.id);
    },
    buildCollapseLogic(notifications){
      notifications.forEach((notType) => {
        notType.isCollapseClicked = false;
        this.notificationClient.forEach((notClient) => {
          if (notType.id === notClient.idNotificationType) {
            notType.active = notClient.enabled;
          }
        });
        if (!notType.active) {
          notType.active = false;
        }
      });
      return notifications
    },
    async save() {
      console.log('Guardando data ', this.notificationTypes);
      this.isConfigurationsReady = false;
      const listEmails = null;
      const updateReady = await this.setNotifications(listEmails);
      console.log('guardado', updateReady);
      if (updateReady) {
        await this.getNotifications();
        this.bodyNotification();
      } else {
        console.log('Fallo el guardado');
      }
      this.isConfigurationsReady = true;
    },
    toogleCollapse(notType, idCollapse) {
      this.selectedType = notType;
      this.selectedType.isCollapseClicked = !this.selectedType.isCollapseClicked;
      this.$root.$emit('bv::toggle::collapse', idCollapse);
    },
    checkComponentPresence(ref) {
      if (this.$refs[ref] && this.$refs[ref].length > 0) {
        return this.$refs[ref][0].show;
      }
    },
    checkBoxStatus() {
      if (!this.subjectCustomerName && !this.subjectClientName){
        this.$bvModal.show('mandatory-element-modal');
        return false;
      }
      if (!this.bodyClientName && !this.bodyCustomerName && !this.bodyDeliveryDate && !this.bodyEstimatedArriveDate && !this.bodyDeliveryAddress && !this.bodyOperationName && !this.bodyReceiverName && !this.bodyReceiverLegalNumber){
        this.$bvModal.show('mandatory-element-modal');
        return false;
      }
      return true;
    },
    async saveNotificationData() {
      if (await this.checkBoxStatus()) {
        this.imageBussy = true;
        if (this.isLogoEnabled == true && this.urlImage == null && this.fileActivity == null) {
          showAlert(
            this.$t(`configurations.modal.errorLogoTitle`),
            this.$t(`configurations.modal.errorLogoBody`),
          ); 

        } else {
          if (this.fileActivity) {
            await this.uploadImage();
          }
          try {
            const url = `${this.$store.getters.urlAPI}/notification/updateMetadata`;
            const config = {
              headers: {
                'id-client': this.$store.getters.clientId,
                Authorization: `Bearer ${this.$store.getters.accessToken}`,
              },
            };
            const body = this.buildBody("metaData");
            const response = await axios.patch(url, body, config);
            if (response.status == 200) {
              this.notificationClient.forEach((noti) => {
                if (noti.metaDataByClient) {
                  noti.metaDataByClient.logo = this.urlImage;
                }
              });
              await this.getNotifications();
              await this.bodyNotification();
              /* showAlert(
                'Exito',
                'Sus ajustes han sido almacenados con exito, en las proximas notificaciones vera los cambios aplicados',
              ); */
              this.isNotificationEditedPending = false;
              this.eventSelectedEdited = null;
              await this.changeTab('notification');
              let index = null;
              let notType = null;
              
              for (let i = 0; i < this.notificationTypes.length; i++) {
                if (this.eventSelected.id == this.notificationTypes[i].id) {
                  index = i;
                  notType = this.notificationTypes[i];
                  break;
                }
              }
              if (index != null && notType != null) {
                this.toogleCollapse(notType,'eventsRoute'+index);
              }
            }
          } catch (e) {
            console.log(e);
          }
        }
        this.imageBussy = false;
      }
    },
    async sendPreview(){
      if (this.checkBoxStatus() && this.checkEmail()) {
        this.cooldown = 20;
        this.isEmailMoreThanOne = false;
        this.isSendPreviewReady = false;
        this.imageBussy = true;
        if (this.fileActivity) {
          await this.uploadImage();
        }
        try {
          const url = `${this.$store.getters.urlAPI}/notification/sendPreview`;
          const config = {
            headers: {
              'id-client': this.$store.getters.clientId,
              Authorization: `Bearer ${this.$store.getters.accessToken}`,
            },
          };
          this.activateCooldown();
          const body = this.buildBody("metaDataByClient");
          const response = await axios.post(url, body, config);
          if (response.status == 200) {
            this.isSendPreviewReady = true;
          }
        } catch (e) {
          this.isSendPreviewReady = false;
          console.log(e);
        }
        this.imageBussy = false;
      }
    },
    buildBody(parameter){
      let body = {
        idNotificationType: this.eventSelected.id,
        [parameter]: {
          clientName: this.$store.getters.clientName,
          subjectCustomerName: this.subjectCustomerName,
          subjectSenderName: this.subjectSenderName,
          subjectClientName: this.subjectClientName,
          isLogoEnabled: this.isLogoEnabled,
          bodyCustomerName: this.bodyCustomerName,
          bodySenderName: this.bodySenderName,
          bodyClientName: this.bodyClientName,
          bodyDeliveryAddress: this.bodyDeliveryAddress,
          bodyOperationName: this.bodyOperationName,
          extraDriverName: this.extraDriverName,
          extraDriverPhone: this.extraDriverPhone,
          extraPlate: this.extraPlate,
          extraDocuments: this.extraDocuments,
          extraTrackingUrl: this.extraTrackingUrl,
          extraTrackingId: this.extraTrackingId,
        },
      };
      console.log("Campo del parametro ",parameter);
      console.log("Campo correo ",this.sendEmail);
      if(parameter == 'metaDataByClient'){
        body.recipients = this.sendEmail;
      }
      if (this.urlImage != null) {
        body[parameter].logo = this.urlImage;
      }
      if (this.eventSelected.eventName == 'SCHEDULED_ORDER') {
        body[parameter].bodyEstimatedArriveDate = this.bodyEstimatedArriveDate;
      }
      if (this.eventSelected.eventName == 'ONROUTE_ORDER') {
        body[parameter].bodyEstimatedArriveDate = this.bodyEstimatedArriveDate;
      }
      if (this.eventSelected.eventName == 'SUCCESSFUL_ORDER') {
        body[parameter].bodyDeliveryDate = this.bodyDeliveryDate;
        body[parameter].bodyReceiverName = this.bodyReceiverName;
        body[parameter].bodyReceiverLegalNumber = this.bodyReceiverLegalNumber;
        body[parameter].extraPhotos = this.extraPhotos;
        body[parameter].extraObservation = this.extraObservation;
        body[parameter].extraSurvey = this.extraSurvey;
      }
      if (this.eventSelected.eventName == 'PARTIAL_ORDER') {
        body[parameter].bodyDeliveryDate = this.bodyDeliveryDate;
        body[parameter].bodyReceiverName = this.bodyReceiverName;
        body[parameter].bodyReceiverLegalNumber = this.bodyReceiverLegalNumber;
        body[parameter].extraPhotos = this.extraPhotos;
        body[parameter].extraObservation = this.extraObservation;
        body[parameter].extraSurvey = this.extraSurvey;
        body[parameter].extraMotiveSubmotive = this.extraMotiveSubmotive;
      }
      if (this.eventSelected.eventName == 'FAILED_ORDER') {
        body[parameter].bodyDeliveryDate = this.bodyDeliveryDate;
        body[parameter].extraPhotos = this.extraPhotos;
        body[parameter].extraObservation = this.extraObservation;
        body[parameter].extraMotiveSubmotive = this.extraMotiveSubmotive;
      }
      return body;
    },
    moreThanOneEmail(){
      if(this.sendEmail && this.sendEmail.length > 0){
        let totalEmails = this.sendEmail.split(/[,;]/);
        if(totalEmails.length > 1){
          return true;
        }
      }
      return false;
    },
    checkEmail(){
      if(this.sendEmail && this.sendEmail.length > 0 && !this.moreThanOneEmail() && this.isEmailValid(this.sendEmail)){
        this.isEmailMoreThanOne = false;
        return true;
      }
      this.isEmailMoreThanOne = true;
      return false;
    },
    isEmailValid(email) {
      const re = /^[a-zA-Z0-9.ñ_%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      return re.test(email.trim());
    },
    async checkExtraData() {
      return this.extraDriverName || this.extraDriverPhone 
              || this.extraPlate || this.extraDocuments 
              || this.extraItems || this.extraTrackingUrl 
              || this.extraTrackingId || this.extraPhotos 
              || this.extraObservation || this.extraSurvey || this.extraMotiveSubmotive;
    },
    async uploadImage() {
      this.fileBase64 = await this.readFileAsync(this.fileActivity);
      this.fileBase64 = this.fileBase64.split(',')[1];
      await this.uploadImageS3();
    },
    readFileAsync(file) {
      return new Promise((resolve, reject) => {
        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
          resolve(reader.result);
        };
        reader.onerror = reject;
      });
    },
    activateCooldown(){
      if (this.cooldown > 0) {
        setTimeout(() => {
          this.cooldown -= 1;
          this.activateCooldown();
        }, 1000);
      }else{
        //Lo coloco false despues del tiempo para evitar que salga el mensaje todo el tiempo
        this.isSendPreviewReady = false;
      }
    },
    async uploadImageS3() {
      let date = new Date(this.$store.getters.dateToken);
      let now = new Date();
      let diff = Math.floor(Math.abs(now - date) / 1000 / 60);
      let rt = this.$store.getters.refreshToken;
      let firstTime = this.$store.getters.firstTimeRefresh;
      console.log(diff);
      if (firstTime || (diff >= 15 && rt)) {
        try {
          //showAlert('Información', this.$t('configurations.modal.waitingForToken'));
          console.log('Obteniendo el nuevo Token');
          const url = `${this.$store.getters.urlSimpleLogin}/refreshToken`;
          const body = {
            refreshToken: rt,
          };
          const response = await axios.post(url, body);
          console.log(response.data.AccessToken);
          this.$store.commit('saveFirstTimeRefresh', false);
          this.$store.commit('saveAccessToken', response.data.AccessToken);
          this.$store.commit('saveDateToken', now);
        } catch (e) {
          console.log(e);
        }
      }
      const url = `${this.$store.getters.urlImage}/simpleimageuploader/upload?project=lastmile&isBase64=true`;
      const config = {
        headers: {
          'id-client': this.$store.getters.clientId,
          Authorization: `Bearer ${this.$store.getters.accessToken}`,
        },
      };
      const body = {
        image: this.fileBase64,
      };
      try {
        const response = await axios.post(url, body, config);
        this.urlImage = response.data.url;
      } catch (e) {
        showAlert('Error', e.response.data);
      }
    },
    onFileInput() {
      this.imageBussy = true;
      const maxSize = 1 * 1024 * 1024; // 1MB en bytes;
      if (this.fileActivity && this.fileActivity.size > maxSize) {
        this.fileActivity = null;
        showAlert('Error', this.$t('configurations.modal.limitSize'));
        this.imageBussy = false;
        return;
      }
      this.urlImage = this.fileActivity ? URL.createObjectURL(this.fileActivity) : null;
      this.imageBussy = false;
    },
    getNameImage(image) {
      console.log(image, image.urlImage);
      let arrayImage = image.urlImage.split('/');
      image.nameImage = arrayImage[arrayImage.length - 1];
    },
    editSpecificNotification(data) {
      this.eventSelected = this.eventList.find((element) => element.eventName == data);
      this.isNotificationEditedPending = false
      this.eventSelectedEdited = null;
      this.handleChangeNotificationTemplate();
      this.changeTab('editNotification');
    },
    restoreCurrentTemplate() {
      if (this.eventSelected.eventName == 'SCHEDULED_ORDER') {
        this.subjectCustomerName = true;
        this.subjectSenderName = false;
        this.subjectClientName = true;
        this.isLogoEnabled = false;
        this.bodyCustomerName = true;
        this.bodySenderName = false;
        this.bodyClientName = true;
        this.bodyDeliveryDate = false;
        this.bodyEstimatedArriveDate = true;
        this.bodyDeliveryAddress = true;
        this.bodyOperationName = true;
        this.bodyReceiverName = false;
        this.bodyReceiverLegalNumber = false;
        this.extraDriverName = false;
        this.extraDriverPhone = false;
        this.extraPlate = false;
        this.extraDocuments = false;
        this.extraItems = false;
        this.extraTrackingUrl = false;
        this.extraTrackingId = false;
        this.extraPhotos = false;
        this.extraObservation = false;
        this.extraSurvey = false;
        this.extraMotiveSubmotive = false;
      }
      if (this.eventSelected.eventName == 'ONROUTE_ORDER') {
        this.subjectCustomerName = true;
        this.subjectSenderName = false;
        this.subjectClientName = true;
        this.isLogoEnabled = false;
        this.bodyCustomerName = true;
        this.bodySenderName = false;
        this.bodyClientName = true;
        this.bodyDeliveryDate = false;
        this.bodyEstimatedArriveDate = true;
        this.bodyDeliveryAddress = true;
        this.bodyOperationName = true;
        this.bodyReceiverName = false;
        this.bodyReceiverLegalNumber = false;
        this.extraDriverName = false;
        this.extraDriverPhone = false;
        this.extraPlate = false;
        this.extraDocuments = false;
        this.extraItems = false;
        this.extraTrackingUrl = true;
        this.extraTrackingId = true;
        this.extraPhotos = false;
        this.extraObservation = false;
        this.extraSurvey = false;
        this.extraMotiveSubmotive = false;
      }
      if (this.eventSelected.eventName == 'SUCCESSFUL_ORDER') {
        this.subjectCustomerName = true;
        this.subjectSenderName = false;
        this.subjectClientName = true;
        this.isLogoEnabled = false;
        this.bodyCustomerName = true;
        this.bodySenderName = false;
        this.bodyClientName = true;
        this.bodyDeliveryDate = true;
        this.bodyEstimatedArriveDate = false;
        this.bodyDeliveryAddress = true;
        this.bodyOperationName = true;
        this.bodyReceiverName = false;
        this.bodyReceiverLegalNumber = false;
        this.extraDriverName = false;
        this.extraDriverPhone = false;
        this.extraPlate = false;
        this.extraDocuments = false;
        this.extraItems = false;
        this.extraTrackingUrl = false;
        this.extraTrackingId = false;
        this.extraPhotos = true;
        this.extraObservation = false;
        this.extraSurvey = true;
        this.extraMotiveSubmotive = false;
      }
      if (this.eventSelected.eventName == 'PARTIAL_ORDER') {
        this.subjectCustomerName = true;
        this.subjectSenderName = false;
        this.subjectClientName = true;
        this.isLogoEnabled = false;
        this.bodyCustomerName = true;
        this.bodySenderName = false;
        this.bodyClientName = true;
        this.bodyDeliveryDate = true;
        this.bodyEstimatedArriveDate = false;
        this.bodyDeliveryAddress = true;
        this.bodyOperationName = true;
        this.bodyReceiverName = false;
        this.bodyReceiverLegalNumber = false;
        this.extraDriverName = false;
        this.extraDriverPhone = false;
        this.extraPlate = false;
        this.extraDocuments = false;
        this.extraItems = false;
        this.extraTrackingUrl = false;
        this.extraTrackingId = false;
        this.extraPhotos = true;
        this.extraObservation = false;
        this.extraSurvey = true;
        this.extraMotiveSubmotive = false;
      }
      if (this.eventSelected.eventName == 'FAILED_ORDER') {
        this.subjectCustomerName = true;
        this.subjectSenderName = false;
        this.subjectClientName = true;
        this.isLogoEnabled = false;
        this.bodyCustomerName = true;
        this.bodySenderName = false;
        this.bodyClientName = true;
        this.bodyDeliveryDate = true;
        this.bodyEstimatedArriveDate = false;
        this.bodyDeliveryAddress = true;
        this.bodyOperationName = true;
        this.bodyReceiverName = false;
        this.bodyReceiverLegalNumber = false;
        this.extraDriverName = false;
        this.extraDriverPhone = false;
        this.extraPlate = false;
        this.extraDocuments = false;
        this.extraItems = false;
        this.extraTrackingUrl = false;
        this.extraTrackingId = false;
        this.extraPhotos = true;
        this.extraObservation = false;
        this.extraSurvey = false;
        this.extraMotiveSubmotive = false;
      }
    },
    checkEditNofiticationPending() {
      if (this.isNotificationEditedPending) {
        this.$bvModal.show('changeEditNotificationConfirm');
      } else {
        this.handleChangeNotificationTemplate();
      }
    },
    revertEditNoficationForm() {
      this.eventSelected = this.eventSelectedEdited;
      this.$bvModal.hide('changeEditNotificationConfirm')
    },
    handleChangeNotificationTemplate() {
      this.$bvModal.hide('changeEditNotificationConfirm');
      this.isNotificationEditedPending = false;
      this.isSendPreviewReady = false;
      this.subjectCustomerName = false;
      this.subjectSenderName = false;
      this.subjectClientName = false;
      this.isLogoEnabled = false;
      this.bodyCustomerName = false;
      this.bodySenderName = false;
      this.bodyClientName = false;
      this.bodyDeliveryDate = false;
      this.bodyEstimatedArriveDate = false;
      this.bodyDeliveryAddress = false;
      this.bodyOperationName = false;
      this.bodyReceiverName = false;
      this.bodyReceiverLegalNumber = false;
      this.extraDriverName = false;
      this.extraDriverPhone = false;
      this.extraPlate = false;
      this.extraDocuments = false;
      this.extraItems = false;
      this.extraTrackingUrl = false;
      this.extraTrackingId = false;
      this.extraPhotos = false;
      this.extraObservation = false;
      this.extraSurvey = false;
      this.extraMotiveSubmotive = false;
      if (this.eventSelected) {
        const notificationMatched = this.notificationClient.find((element) => element.idNotificationType == this.eventSelected.id);
        if (notificationMatched) {
          if (notificationMatched.metaDataByClient) {
            if (notificationMatched.metaDataByClient.subjectCustomerName) {
              this.subjectCustomerName = notificationMatched.metaDataByClient.subjectCustomerName == 'true';
            }
            if (notificationMatched.metaDataByClient.subjectSenderName) {
              this.subjectSenderName = notificationMatched.metaDataByClient.subjectSenderName == 'true';
            }
            if (notificationMatched.metaDataByClient.subjectClientName) {
              this.subjectClientName = notificationMatched.metaDataByClient.subjectClientName == 'true';
            }
            if (notificationMatched.metaDataByClient.isLogoEnabled) {
              this.isLogoEnabled = notificationMatched.metaDataByClient.isLogoEnabled == 'true';
            }
            if (notificationMatched.metaDataByClient.bodyCustomerName) {
              this.bodyCustomerName = notificationMatched.metaDataByClient.bodyCustomerName == 'true';
            }
            if (notificationMatched.metaDataByClient.bodySenderName) {
              this.bodySenderName = notificationMatched.metaDataByClient.bodySenderName == 'true';
            }
            if (notificationMatched.metaDataByClient.bodyClientName) {
              this.bodyClientName = notificationMatched.metaDataByClient.bodyClientName == 'true';
            }
            if (notificationMatched.metaDataByClient.bodyDeliveryDate) {
              this.bodyDeliveryDate = notificationMatched.metaDataByClient.bodyDeliveryDate == 'true';
            }
            if (notificationMatched.metaDataByClient.bodyEstimatedArriveDate) {
              this.bodyEstimatedArriveDate = notificationMatched.metaDataByClient.bodyEstimatedArriveDate == 'true';
            }
            if (notificationMatched.metaDataByClient.bodyDeliveryAddress) {
              this.bodyDeliveryAddress = notificationMatched.metaDataByClient.bodyDeliveryAddress == 'true';
            }
            if (notificationMatched.metaDataByClient.bodyOperationName) {
              this.bodyOperationName = notificationMatched.metaDataByClient.bodyOperationName == 'true';
            }
            if (notificationMatched.metaDataByClient.bodyReceiverName) {
              this.bodyReceiverName = notificationMatched.metaDataByClient.bodyReceiverName == 'true';
            }
            if (notificationMatched.metaDataByClient.bodyReceiverLegalNumber) {
              this.bodyReceiverLegalNumber = notificationMatched.metaDataByClient.bodyReceiverLegalNumber == 'true';
            }
            if (notificationMatched.metaDataByClient.extraDriverName) {
              this.extraDriverName = notificationMatched.metaDataByClient.extraDriverName == 'true';
            }
            if (notificationMatched.metaDataByClient.extraDriverPhone) {
              this.extraDriverPhone = notificationMatched.metaDataByClient.extraDriverPhone == 'true';
            }
            if (notificationMatched.metaDataByClient.extraPlate) {
              this.extraPlate = notificationMatched.metaDataByClient.extraPlate == 'true';
            }
            if (notificationMatched.metaDataByClient.extraDocuments) {
              this.extraDocuments = notificationMatched.metaDataByClient.extraDocuments == 'true';
            }
            if (notificationMatched.metaDataByClient.extraItems) {
              this.extraItems = notificationMatched.metaDataByClient.extraItems == 'true';
            }
            if (notificationMatched.metaDataByClient.extraTrackingUrl) {
              this.extraTrackingUrl = notificationMatched.metaDataByClient.extraTrackingUrl == 'true';
            }
            if (notificationMatched.metaDataByClient.extraTrackingId) {
              this.extraTrackingId = notificationMatched.metaDataByClient.extraTrackingId == 'true';
            }
            if (notificationMatched.metaDataByClient.extraPhotos) {
              this.extraPhotos = notificationMatched.metaDataByClient.extraPhotos == 'true';
            }
            if (notificationMatched.metaDataByClient.extraObservation) {
              this.extraObservation = notificationMatched.metaDataByClient.extraObservation == 'true';
            }
            if (notificationMatched.metaDataByClient.extraSurvey) {
              this.extraSurvey = notificationMatched.metaDataByClient.extraSurvey == 'true';
            }
            if (notificationMatched.metaDataByClient.extraMotiveSubmotive) {
              this.extraMotiveSubmotive = notificationMatched.metaDataByClient.extraMotiveSubmotive == 'true';
            }
            if (
              !this.subjectCustomerName && 
              !this.subjectSenderName && 
              !this.subjectClientName && 
              !this.isLogoEnabled && 
              !this.bodyCustomerName && 
              !this.bodySenderName && 
              !this.bodyClientName && 
              !this.bodyDeliveryDate && 
              !this.bodyEstimatedArriveDate && 
              !this.bodyDeliveryAddress && 
              !this.bodyOperationName && 
              !this.bodyReceiverName && 
              !this.bodyReceiverLegalNumber && 
              !this.extraDriverName && 
              !this.extraDriverPhone && 
              !this.extraPlate && 
              !this.extraDocuments && 
              !this.extraItems && 
              !this.extraTrackingUrl && 
              !this.extraTrackingId && 
              !this.extraPhotos && 
              !this.extraObservation && 
              !this.extraSurvey && 
              !this.extraMotiveSubmotive) {
                this.restoreCurrentTemplate();
              }
          } else {
            this.restoreCurrentTemplate();
          }
        } else {
          this.restoreCurrentTemplate();
        }
      }
      this.refreshTemplate();
    },
    refreshTemplate() {
      this.refreshUrlImage = this.urlImage;
      this.refreshSubjectCustomerName = this.subjectCustomerName;
      this.refreshSubjectSenderName = this.subjectSenderName;
      this.refreshSubjectClientName = this.subjectClientName;
      this.refreshIsLogoEnabled = this.isLogoEnabled;
      this.refreshBodyCustomerName = this.bodyCustomerName;
      this.refreshBodySenderName = this.bodySenderName;
      this.refreshBodyClientName = this.bodyClientName;
      this.refreshBodyDeliveryDate = this.bodyDeliveryDate;
      this.refreshBodyEstimatedArriveDate = this.bodyEstimatedArriveDate;
      this.refreshBodyDeliveryAddress = this.bodyDeliveryAddress;
      this.refreshBodyOperationName = this.bodyOperationName;
      this.refreshBodyReceiverName = this.bodyReceiverName;
      this.refreshBodyReceiverLegalNumber = this.bodyReceiverLegalNumber;
      this.refreshExtraDriverName = this.extraDriverName;
      this.refreshExtraDriverPhone = this.extraDriverPhone;
      this.refreshExtraPlate = this.extraPlate;
      this.refreshExtraDocuments = this.extraDocuments;
      this.refreshExtraItems = this.extraItems;
      this.refreshExtraTrackingUrl = this.extraTrackingUrl;
      this.refreshExtraTrackingId = this.extraTrackingId;
      this.refreshExtraPhotos = this.extraPhotos;
      this.refreshExtraObservation = this.extraObservation;
      this.refreshExtraSurvey = this.extraSurvey;
      this.refreshExtraMotiveSubmotive = this.extraMotiveSubmotive;
    },
    editNotificationFormEdited() {
      if (!this.isNotificationEditedPending) {
        this.eventSelectedEdited = this.eventSelected;
        this.isNotificationEditedPending = true;
      }
    }
  },
  computed: {
    emailsNotification() {
      const common = {
        thClass: 'text-center',
        tdClass: 'text-center',
      };
      return [
        {
          key: 'email',
          label: this.$t('configurations.modal.emailTable.email'),
          ...common,
        },
        {
          key: 'actions',
          label: this.$t('configurations.modal.emailTable.actions'),
          ...common,
        },
      ];
    },
  },
  watch :{
  }
};
